const BlueTag = ({ children, onClick }) => {
  return (
    <span
      onClick={onClick}
      className="text-white bg-appblue rounded-md text-sm"
      style={{ padding: "7.5px 12px" }}
    >
      {children}
    </span>
  );
};

export default BlueTag;
